import { theme } from '@truepill/react-capsule'
import usePane from 'hooks/usePane'
import { Fab } from 'components'

export const NotesButton = ({ count }: { count?: number }) => {
  const { togglePane } = usePane('Note')

  return (
    <Fab
      icon={'Book'}
      badge={count}
      toolTipProps={{ label: 'Notes' }}
      onClick={togglePane}
      css={{ backgroundColor: theme.colors['gray-300'].value }}
    />
  )
}
